
// State management
import { mapActions, mapGetters, mapState } from 'vuex'

// Local components
import ProductPrice from '~/components/product-details/ProductPrice'
import RatingStars from '~/components/reviews/RatingStars'

export default {
  name: 'QuickShop',
  components: {
    ProductPrice,
    RatingStars
  },
  props: {
    productId: {
      type: String,
      default: undefined,
    },
    backgroundColor: {
      type: String,
      required: false,
      default: ''
    },
    textColor: {
      type: String,
      required: false,
      default: ''
    },
    textContentMobile: {
      type: Array,
      default: () => [],
    },
    textContentDesktop: {
      type: Array,
      default: () => [],
    },
    footerNotice: {
      type: String,
      default: undefined,
    },
    showProductReviews: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    product: null,
    productID: null,
    selectVariant: null,
    swatchDescription: null,
    error: false,
    productImages: [],
  }),
  computed: {
    ...mapGetters({
      getYotpoReviews: 'yotpo/getProductReviews',
      getCentraProduct: 'centra-product/getProductById',
    }),
    ...mapState({
      loadingYotpoReviews: state => state.yotpo?.loadingReviews,
    }),
    swatches: ({ product }) =>
      product?.swatchProducts || [],
    hasMobileContent () {
      return this.textContentMobile.length > 0
    },
    hasDesktopContent () {
      return this.textContentDesktop.length > 0
    },
    yotpoReviews () {
      return this.getYotpoReviews(this.product?.productSku)
    },
    score: ({ yotpoReviews }) =>
      yotpoReviews?.bottomline?.average_score || 0,
    hasReviews () {
      return !(this.yotpoReviews === null || this.yotpoReviews?.reviews?.length === 0)
    },
    numOfReviews () {
      return this.yotpoReviews?.bottomline?.total_review || 0
    },
    wishListEnabled () {
      return this.$config.whishlistEnabled
    },
    hasFooterNotice () {
      return this.footerNotice?.length > 0
    },
  },
  async mounted () {
    if (!this.productID || !this.product) {
      await this.getProduct()
    }
    await this.loadYotpoReviews({ sku: this.product?.productSku })
  },
  methods: {
    ...mapActions({
      loadYotpoReviews: 'yotpo/loadProductReviews',
    }),
    async getProduct (id) {
      this.error = false
      let centraProduct = await this.getCentraProduct(id ?? this.productId)

      if (!centraProduct) {
        await this.$store.dispatch('centra-product/lookupProducts', [id ?? this.productId])
        centraProduct = await this.getCentraProduct(id ?? this.productId)

        if (!centraProduct) {
          console.error('Product not found')
          this.error = true
          return
        }
      }

      this.product = centraProduct
      this.productID = centraProduct?.product
      this.selectVariant = centraProduct?.variantName
      this.swatchDescription = centraProduct.color_swatch?.description
      this.productImages = centraProduct?.media
    },

    switchVariant (swatch) {
      this.selectVariant = swatch.variantName
      this.swatchDescription = swatch.variantName
      this.productID = swatch.product

      this.getProduct(swatch.product)
    },
    openSizeSelector (viewport) {
      const action = viewport === 'desktop'
        ? 'showSizeSelectorDesktop'
        : 'showSizeSelectorMobile'
      this.$store.dispatch(
        `ui/${action}`,
        {
          productID: this.productID,
          discontinued: this.product.discontinued,
          productItems: this.product.items
        }
      )
    },
  },
}
